import { Grid } from '@mui/material'
import { memo, useCallback, useMemo } from 'react'
import { FormFieldType } from 'types/types';
import { EFormFieldType } from 'enum/EFormFieldType';
import FormField from 'components/inputs/FormField/FormField';
import { enumToLabelValueList } from 'common/utils';
import { EWeightUnit } from 'enum';



function ProductInformationForm() {

  const fields: FormFieldType[] = useMemo(() => {
    return [
      {
        name: 'translations.en.name',
        type: EFormFieldType.TEXT,
        placeholder: 'English name',
        label: 'English Name',
        required: true,
        visible: true,
      },
      {
        name: 'translations.ar.name',
        type: EFormFieldType.TEXT,
        placeholder: 'Arabic name',
        label: 'Arabic Name',
        required: true,
        visible: true,
      },
      // Neither is required, because a product has one or the other and never
      // both: the pack states its contents, or nobody could read them and the
      // size was judged from a photo. Demanding both left the form permanently
      // invalid, so the save button could not be pressed at all.
      {
        name: 'weight',
        type: EFormFieldType.NUMBER,
        placeholder: 'Weight',
        label: 'Weight',
        required: false,
        visible: true,
      },
      {
        name: 'estimatedWeight',
        type: EFormFieldType.NUMBER,
        placeholder: 'Estimated weight',
        label: 'Estimated Weight',
        required: false,
        visible: true,
      },
      {
        name: 'drainedWeight',
        type: EFormFieldType.NUMBER,
        placeholder: 'Drained weight',
        label: 'Drained Weight',
        required: false,
        visible: true,
      },
      {
        name: 'weightUnit',
        type: EFormFieldType.DROPDOWN,
        placeholder: 'Weight unit',
        label: 'Weight Unit',
        required: true,
        options: enumToLabelValueList(EWeightUnit),
        visible: true,
      },
      {
        name: 'countryOfManufactureISO',
        type: EFormFieldType.TEXT,
        placeholder: 'Country of Manufacture',
        label: 'Country of Manufacture',
        required: false,
        visible: true,
      },
      {
        name: 'countryOfRegistrationISO',
        type: EFormFieldType.TEXT,
        placeholder: 'Country of Registration',
        label: 'Country of Registration',
        required: true,
        visible: true,
      },
      {
        name: 'barcode',
        type: EFormFieldType.TEXT,
        placeholder: 'Barcode',
        label: 'Barcode',
        required: true,
        visible: true,
      },
      {
        name: 'price',
        type: EFormFieldType.PRICE,
        placeholder: 'Price',
        label: 'Price',
        required: true,
        visible: true,
      },
    ]
  }, []);


  const renderFields = useCallback(() => {
    return (
      <>
        {fields.map((field) =>
          field.visible ? <FormField key={field.name} field={field} /> : null
        )}
      </>
    );
  }, [fields]);

  return (
    <Grid container spacing={1.5}>
      {renderFields()}
    </Grid>
  )
}

export default memo(ProductInformationForm);
